<div class="app-theme">

  <ng-container *ngIf="loading">
    <div class="loading-bar">
        <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
</div>
</ng-container>

      <div class="topborder">
            <select class="form-control" [(ngModel)]="Selectedvenue" (change) = "onVenueChange()">
                <option value="">Please Select a Venue</option>
                <option *ngFor="let venue of venuelist" [value]="venue.key">
                  {{ venue.value.name }}
                </option>
              </select>

            <input 
              [(ngModel)]="date" 
              type="date" 
              id="start" 
              name="trip-start" 
              value="{{date}}"
              min="2018-01-01" 
              max="{{ currentDate }}" 
              class="form-control"
              (change) = "onDateChange()"
               />

               <ng-container *ngIf = "dateRange">
                <input 
                  [(ngModel)]="endDate" 
                  type="date" 
                  id="start" 
                  name="trip-start" 
                  value="{{endDate}}"
                  min="{{date}}" 
                  max="{{ currentDate }}" 
                  class="form-control"
                   />
               </ng-container>
              
              <tm1-text-field ngDefaultControl ="barcode"  (change)="onBarcodeChange($event)" appearance="filled"
              inputsize="regular" [disabled] = "section != ''" labelposition="" minlengtherror="" patternerror="" error="" maxlength="20" minlength="2"
              placeholder="Barcode" size="20" type="text" value="{{barcode}}" charactercountlabel="character(s) left"></tm1-text-field>

              <tm1-text-field ngDefaultControl  [(ngModel)]="section" (change)="onSectionChange($event)" style="padding-left: 10px" appearance="filled"
              inputsize="regular" [disabled] = "barcode != ''" labelposition="" minlengtherror="" patternerror="" error="" maxlength="20"
              placeholder="Section" size="20" type="text" value="{{section}}" charactercountlabel="character(s) left"></tm1-text-field>
          
              <tm1-text-field ngDefaultControl [(ngModel)]="row" (change)="onRowChange($event)" style=" padding-left: 10px" appearance="filled"
              inputsize="regular" [disabled] = "barcode != ''" labelposition="" minlengtherror="" patternerror="" error="" maxlength="20"
              placeholder="Row" size="20" type="text" value="{{row}}" charactercountlabel="character(s) left"></tm1-text-field>
          
              <tm1-text-field ngDefaultControl  [(ngModel)]="seat" (change)="onSeatChange($event)" style="  padding-left: 10px" appearance="filled"
              inputsize="regular" [disabled] = "barcode != ''" labelposition="" minlengtherror="" patternerror="" error="" maxlength="20"
              placeholder="Seat" size="20" type="text" value="{{seat}}" charactercountlabel="character(s) left"></tm1-text-field>

              <tm1-checkbox 
                  class="dateRangeCheck" 
                  (change)="selectDateRangeChangeHandler($event)" 
                  error="" 
                  size="medium"
                  [checked] = "toggleDateRangeCheckBox()"
                  value="">
                  Search Date Range
                </tm1-checkbox>
            
              <tm1-button style="margin-left: 1%;" (click)="clearFields();" appearance="filled" color="negative"
              size="regular" type="submit" class="">Clear Fields</tm1-button>
    
              <tm1-button style="margin-left: 1%;" (click)="getScanHistory($event);" appearance="filled" color="primary"
              size="regular" type="submit" class="">Search</tm1-button>
            </div>

            <div class = cointainer>
                <tm1-card>
                   <div class="table-container-scanHistory">
                  <tm1-data-grid class="tm1-data-grid" >
                    <tm1-data-grid-row class="tm1-data-grid-row" row-type="sticky-header">
                      <tm1-data-grid-cell grid-column="1" cell-type="columnheader">Date & Time</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="2" cell-type="columnheader">Barcode</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="3" cell-type="columnheader">Event Code</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="4" cell-type="columnheader">Section</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="5" cell-type="columnheader">Row</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="6" cell-type="columnheader">Seat</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="7" cell-type="columnheader">Entrance</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="8" cell-type="columnheader">Device</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="9" cell-type="columnheader">Source</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="10" cell-type="columnheader">Scan Response</tm1-data-grid-cell>
                      <tm1-data-grid-cell grid-column="11" cell-type="columnheader">Type</tm1-data-grid-cell>
                    </tm1-data-grid-row>
                    <tm1-data-grid-row>
                      <ng-container *ngFor="let scan of scanHistorySummary">
                        <tm1-data-grid-cell grid-column="1">{{scan.formattedDateTime}}</tm1-data-grid-cell>
                        <tm1-data-grid-cell grid-column="2">{{scan.ticket.barcode}}</tm1-data-grid-cell>
                        <tm1-data-grid-cell grid-column="3">{{scan.event.eventCode}}</tm1-data-grid-cell>
                        <tm1-data-grid-cell grid-column="4">{{scan.ticket.place.section}}</tm1-data-grid-cell>
                        <tm1-data-grid-cell grid-column="5">{{scan.ticket.place.row}}</tm1-data-grid-cell>
                        <tm1-data-grid-cell grid-column="6">{{scan.ticket.place.seat}}</tm1-data-grid-cell>
                        <tm1-data-grid-cell grid-column="7">{{scan.entrance.name}}</tm1-data-grid-cell>
                        <tm1-data-grid-cell grid-column="8">{{scan.scanner.name}}</tm1-data-grid-cell>
                        <tm1-data-grid-cell grid-column="9">{{scan.event.source}}</tm1-data-grid-cell>
                        <ng-container *ngIf="scan.scan.result.code == 'OKAY'">
                          <tm1-data-grid-cell style="background-color: lightgreen;" grid-column="10">Entered</tm1-data-grid-cell>
                        </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'INTERNAL_SCAN'">
                          <tm1-data-grid-cell style="background-color: lightgreen;" grid-column="10">Internal
                            Entry</tm1-data-grid-cell>
                        </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'INTERNAL_SCAN_EXIT'">
                          <tm1-data-grid-cell style="background-color: orange;" grid-column="10">Internal Exit</tm1-data-grid-cell>
                        </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'INTERNAL_SCAN_ALREADY_ENTERED'">
                          <tm1-data-grid-cell style="background-color: lightsalmon;" grid-column="10">Internal Already
                            Entered</tm1-data-grid-cell>
                        </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'EXIT'">
                          <tm1-data-grid-cell style="background-color: orange;" grid-column="10">Exited</tm1-data-grid-cell>
                        </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'INTERNAL_SCAN_EXIT_NOT_PERMITTED'">
                          <tm1-data-grid-cell style="background-color: lightsalmon;" grid-column="10">Internal Already
                            Internal Exit Not Permitted</tm1-data-grid-cell>
                        </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'ALREADY_ENTERED'">
                          <tm1-data-grid-cell style="background-color: lightsalmon;" grid-column="10">
                            Already Entered</tm1-data-grid-cell>
                        </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'EXIT_NOT_PERMITTED'">
                          <tm1-data-grid-cell style="background-color: lightsalmon;" grid-column="10">
                            Exit Not Permitted</tm1-data-grid-cell>
                        </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'SECTION_RESTRICTION'">
                            <tm1-data-grid-cell style="background-color: lightsalmon;" grid-column="10">
                              Section Restriction</tm1-data-grid-cell>
                          </ng-container>
                          <ng-container *ngIf="scan.scan.result.code == 'EVENT_RESTRICTION'">
                            <tm1-data-grid-cell style="background-color: lightsalmon;" grid-column="10">
                              Event Restriction</tm1-data-grid-cell>
                          </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'INVALID_TICKET'">
                          <tm1-data-grid-cell style="background-color: lightsalmon;" grid-column="10">
                            Invalid Ticket</tm1-data-grid-cell>
                        </ng-container>
                        <ng-container *ngIf="scan.scan.result.code == 'SAFETIX_INVALID'">
                          <tm1-data-grid-cell style="background-color: lightsalmon;" grid-column="10">
                            Non Entry Barcode (Safetix Invalid)</tm1-data-grid-cell>
                        </ng-container>
                        <tm1-data-grid-cell grid-column="11">{{scan.scan.mediaType}}</tm1-data-grid-cell>
                      </ng-container>
                    </tm1-data-grid-row>
                  </tm1-data-grid>
                  </div>
                </tm1-card>
                </div>
            </div>